export const RELATIVE_PATH = {
  search: '/workflow/marketing-templates/search',
  marketingTemplates: '/workflow/marketing-templates',
};
